var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cptFlag)?_c('el-carousel',{staticClass:"carousel-el pc-margin-bottom30-mobil-margin-bottom20 border-radius5",attrs:{"height":_vm.carouselHeight}},_vm._l((_vm.computedList),function(item,index){return _c('el-carousel-item',{key:index},[_c('div',{staticClass:"bg-img-box",class:{pointer: _vm.getIsPointer(item)},style:({
          backgroundImage: `url(${_vm.getImgUrl(item)})`,
        }),on:{"click":function($event){return _vm.carouselImageHandle(item)}}})])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }